// extracted by mini-css-extract-plugin
export var headerCell = "_54-1";
export var loadingSpinnerContainer = "_54-4";
export var rowWrapper = "_54-3";
export var standaloneTable = "_54-5";
export var table = "_54-0";
export var white = "_54-2";